import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  // GET roles
  getAllQuotation(langCode: string): Observable<any> {
    if(langCode === ""){
      return this.http.get(`${this.apiUrl}quote`);
    }
    else{
      return this.http.get(`${this.apiUrl}quote?lang=${langCode}`);
    }
  }

  getQuotationById(id: number,langCode: string): Observable<any> {
    if(langCode === ""){
      return this.http.get(`${this.apiUrl}quote/${id}`);
    }
    else {
      return this.http.get(`${this.apiUrl}quote/${id}?lang=${langCode}`);
    }
  }

  create(request: any): Observable<any> {
    const formData = new FormData();
    formData.append('image', request.image);
    formData.append('Data', JSON.stringify(request.data));

    return this.http.post(`${this.apiUrl}quote`, formData);
  }

  update(id: number,request: any): Observable<any> {

    const formData = new FormData();
    formData.append('image', request.image);
    formData.append('Data', JSON.stringify(request.data));

    return this.http.put(`${this.apiUrl}quote/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}quote/${id}`);
  }
}
